import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ValuesSection } from './components/ValuesSection';
import { ServicesSection } from './components/ServicesSection';
import { DetailedServicesSection } from './components/DetailedServicesSection';
import { ProcessSection } from './components/ProcessSection';
import { PortfolioSection } from './components/PortfolioSection';
import { PhilosophySection } from './components/PhilosophySection';
import { ServiceDetailsSection } from './components/ServiceDetailsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { BookingFormSection } from './components/BookingFormSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FAFAF8] text-[#1A1A1A] selection:bg-[#D4AF37] selection:text-[#FAFAF8]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ValuesSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <DetailedServicesSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <PortfolioSection data-id="element-8" />
        <PhilosophySection data-id="element-9" />
        <ServiceDetailsSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <ContactSection data-id="element-12" />
        <BookingFormSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}